import { useState } from "react";

export default function useLoginForm() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let formErrors = {};

    // Email / mobile validation
    if (!identifier.trim()) {
      formErrors.identifier = "Email or mobile is required";
    } else if (
      !/^\S+@\S+\.\S+$/.test(identifier) && 
      !/^[0-9]{10}$/.test(identifier)
    ) {
      formErrors.identifier = "Enter a valid email or 10-digit mobile";
    }

    // Password validation
    if (!password.trim()) {
      formErrors.password = "Password is required";
    } else if (password.length < 6) {
      formErrors.password = "Password must be at least 6 characters";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  return {
    identifier,
    password,
    captchaVerified,
    errors,
    setIdentifier,
    setPassword,
    setCaptchaVerified,
    validateForm,
  };
}
